export const HELP_TEXT = [
  {
    icon: '🔄',
    title: 'Rotate',
    text: 'Fix sideways or reversed photos.',
  },
  {
    icon: '↩️',
    title: 'Undo and redo',
    text: 'Made a mistake? Use undo or redo to step backwards or forwards through your recent edits.',
  },
  {
    icon: '✂️',
    title: 'Crop',
    text: 'Trim the image so the animal is the main focus.',
  },
  {
    icon: '✏️',
    title: 'Text',
    text: 'Add important adoption details in clear, readable writing.',
  },
  {
    icon: '🎨',
    title: 'Adjust and filters',
    text: 'Improve brightness, contrast and overall clarity.',
  },
  {
    icon: '🫣',
    title: 'Stickers',
    text: 'Use stickers to cover faces or private details.',
  },
];
